import React, { useEffect, useState } from "react";
import { RadioContainer } from "../../commons";
import Select from "react-select";
import {
  CurrencyExchangeDetailsType,
  TCSDetailsType,
  TDSDetailsType,
} from "../../../redux/masterData/masterTypes";
import { GetTdsMasterPayloadType } from "../../../commonTypes/masterDataTypes";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import { components } from "react-select";
import {
  getMasterTcsModuleAction,
  getMasterTdsModuleAction,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
  resetTcsModuleList,
  resetTdsModuleList,
  resetTdsSingleData,
} from "../../../redux/masterData";
import useDebounce from "../../../customHooks/useDebounce";

type AppProps = {
  data: any | undefined;

  type?: string;
  client_code?: any;
  token: any;
  history?: any;
  count?: number | undefined;

  // fetchNewData: Function;
  totalValue: any;
  setTds?: any;
  setTcs?: any;
  tds?: any;
  tcs?: any;
  // loginData?: any;
  currencySign: string | undefined;
  currencyExchangeDetails?: CurrencyExchangeDetailsType | undefined;
  primaryData?: any;
  currencyExchangeError?: string | null;
  clientCurrencyShortForm?: string | undefined;
  clientCurrencyName?: string | undefined;
  dispatchGetTdsModuleAction: (data: GetTdsMasterPayloadType) => void;
  dispatchGetTcsModuleAction: (data: GetTdsMasterPayloadType) => void;
  masterFetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  tdsDataList: TDSDetailsType[] | [];
  tcsDataList: TCSDetailsType[] | [];
  setTcsTdsData: any;
  singleInvoiceDetails?: any | null;
  dispatchResetTcsList: () => void;
  dispatchResetTdsList: () => void;
  setChangeTCSTDSRadioValue: React.Dispatch<React.SetStateAction<string>>;
  changeTCSTDSRadioValue: string;
  tdsDataTotalCount: number;
  tcsDataTotalCount: number;
  tdsTcsvalue: any;
  setTdsTcsValue: any;
  tdstcsChanges: boolean;
  setTdsChanges: React.Dispatch<React.SetStateAction<boolean>>;
  taxableValueSum: number;
};

const TDS_TCS_RADIO_OPTIONS = [
  {
    id: "TDS",
    name: "TDS",
  },
  {
    id: "TCS",
    name: "TCS",
  },
];

const TDSTCS = ({
  data = [],
  masterFetching,
  totalValue,
  setTds,
  setTcs,
  tds,
  tcs,
  // loginData,
  currencySign,
  currencyExchangeDetails,
  primaryData,
  clientCurrencyShortForm,
  dispatchGetTdsModuleAction,
  dispatchGetTcsModuleAction,
  token,
  tdsDataList,
  setTcsTdsData,
  singleInvoiceDetails,
  tcsDataList,
  setChangeTCSTDSRadioValue,
  changeTCSTDSRadioValue,
  tdsDataTotalCount,
  tcsDataTotalCount,
  tdsTcsvalue,
  setTdsTcsValue,
  tdstcsChanges,
  setTdsChanges,
  taxableValueSum,
  dispatchResetTcsList,
  dispatchResetTdsList,
}: AppProps) => {
  const currentCurrencyDetails = primaryData?.find(
    (el: any) => el?.column_name === "currency"
  )?.column_value;

  useEffect(() => {
    dispatchResetTcsList();
    dispatchResetTdsList();
  }, []);

  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [text, setText] = useState("");
  const [tdsTcsdata, setTdsTcsData] = useState<any[]>([]);

  const handleChangeRadioValue = (radioValue: string) => {
    setTds(0);
    setTcs(0);
    setChangeTCSTDSRadioValue(radioValue);
    setTdsTcsValue({
      label: "Select..",
      value: null,
      id: 0,
      rate: 0,
      section_name: "",
    });
  };

  useEffect(() => {
    if (
      !!singleInvoiceDetails?.invoice_data?.tds_tcs_details?.id &&
      !tdstcsChanges
    ) {
      // let totalPercentage =
      //   (singleInvoiceDetails?.invoice_data?.tds_tcs_details?.amount /
      //     totalValue) *
      //   100;

      setTdsTcsValue({
        label: `${singleInvoiceDetails?.invoice_data?.tds_tcs_details?.details?.section_name} (${singleInvoiceDetails?.invoice_data?.tds_tcs_details?.rate}%)`,
        value: singleInvoiceDetails?.invoice_data?.tds_tcs_details?.id,
        id: singleInvoiceDetails?.invoice_data?.tds_tcs_details?.rate,
        section_name:
          singleInvoiceDetails?.invoice_data?.tds_tcs_details?.details
            ?.section_name,
      });

      setTcsTdsData({
        type: singleInvoiceDetails?.invoice_data?.tds_tcs_details?.type,
        id: singleInvoiceDetails?.invoice_data?.tds_tcs_details?.id,
        amount: singleInvoiceDetails?.invoice_data?.tds_tcs_details?.amount,
        rate: singleInvoiceDetails?.invoice_data?.tds_tcs_details?.rate,
        section_name:
          singleInvoiceDetails?.invoice_data?.tds_tcs_details?.details
            ?.section_name,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleInvoiceDetails, tdstcsChanges]);

  useEffect(() => {
    setTcsTdsData({
      type: changeTCSTDSRadioValue?.toLowerCase(),
      id: tdsTcsvalue?.value,
      amount: changeTCSTDSRadioValue === "TDS" ? tds : tcs,
      rate: tdsTcsvalue?.id,
      section_name: tdsTcsvalue.section_name,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tdsTcsvalue, changeTCSTDSRadioValue, tds, tcs]);

  const fetchData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      searchValue: text,
    };
    if (changeTCSTDSRadioValue === "TDS") {
      // dispatchResetTcsList();
      dispatchGetTdsModuleAction(finalData);
    } else {
      // dispatchResetTdsList();

      dispatchGetTcsModuleAction(finalData);
    }
  };
  useDebounce(
    () => {
      if (text) {
        fetchData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          searchValue: text,
        };
        if (changeTCSTDSRadioValue === "TDS") {
          // dispatchResetTcsList();
          dispatchGetTdsModuleAction(finalData);
        } else {
          // dispatchResetTdsList();
          dispatchGetTcsModuleAction(finalData);
        }
      }
    },
    500,
    [text]
  );

  let voucherInvoiceDate = primaryData?.find(
    (e: any) => e.name === "Voucher/Invoice Date"
  );
  useEffect(() => {
    if (token) {
      let finalData: GetTdsMasterPayloadType = {
        token,
        limit,
        offset,
      };
      if (changeTCSTDSRadioValue === "TDS" && offset <= +tdsDataTotalCount) {
        // dispatchResetTcsList();
        dispatchGetTdsModuleAction(finalData);
      } else {
        // dispatchResetTdsList();
        if (offset <= +tcsDataTotalCount) {
          dispatchGetTcsModuleAction(finalData);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeTCSTDSRadioValue, offset, voucherInvoiceDate?.column_value]);

  useEffect(() => {
    if (tdsDataList?.length > 0 && changeTCSTDSRadioValue === "TDS") {
      // dispatchResetTdsList();
      let finalTdsDataList = tdsDataList?.map((el: TDSDetailsType) => {
        let finalRate = el?.tds_rates;
        let tdsTcsData = el?.tds_rates?.[el?.tds_rates?.length - 1];

        for (var i = 0; i < finalRate.length; i++) {
          if (
            new Date(finalRate[i]?.tds_date) <=
            new Date(voucherInvoiceDate?.column_value)
          ) {
            tdsTcsData = finalRate[i];
            break;
          }
        }
        return {
          value: el?.tds_id,
          label: `${el?.section_name} (${tdsTcsData?.tds_rate}%) ^${
            el?.code ? ":" : ""
          } ${el?.code ? el?.code : ""} ^${
            el?.nature_of_payment ? el?.nature_of_payment : ""
          }`,
          id: tdsTcsData?.tds_rate,
          section_name: el?.section_name,
        };
      });

      if (offset > 0) {
        setTdsTcsData((prv: any) => [...prv, ...finalTdsDataList]);
      } else {
        setTdsTcsData(finalTdsDataList);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tdsDataList]);

  useEffect(() => {
    if (tcsDataList?.length > 0 && changeTCSTDSRadioValue === "TCS") {
      let finalTcsDataList = tcsDataList?.map((el: TCSDetailsType) => {
        let finalRate = el?.tcs_rates;
        let tdsTcsData = el?.tcs_rates?.[el?.tcs_rates?.length - 1];
        for (var i = 0; i < finalRate.length; i++) {
          if (
            new Date(finalRate[i]?.tcs_date) <=
            new Date(voucherInvoiceDate?.column_value)
          ) {
            tdsTcsData = finalRate[i];
            break;
          }
        }
        return {
          value: el?.tcs_id,
          label: `${el?.section_name} (${tdsTcsData?.tcs_rate}%) ^${
            el?.code ? ":" : ""
          } ${el?.code ? el?.code : ""} ^${
            el?.nature_of_payment ? el?.nature_of_payment : ""
          }`,
          id: tdsTcsData?.tcs_rate,
          section_name: el?.section_name,
        };
      });

      // setTdsTcsData(finalTcsDataList);
      if (offset > 0) {
        setTdsTcsData((prv: any) => [...prv, ...finalTcsDataList]);
      } else {
        setTdsTcsData(finalTcsDataList);
      }
    }
    // else {
    //   setTdsTcsData(tdsDataList);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tcsDataList]);

  const showConvertedCurrency = (
    amount: number,
    tds: number,
    action?: string
  ) => {
    const adjustedTds = action === "minus" ? tds : -tds;

    if (
      currencyExchangeDetails?.baseCurrency !== clientCurrencyShortForm &&
      currencyExchangeDetails?.rate
    ) {
      const baseAmount = amount - adjustedTds;
      const convertedAmount =
        baseAmount *
        (currencyExchangeDetails?.rate ? +currencyExchangeDetails?.rate : 1);

      return (
        <div>
          <span
            style={{
              fontSize: "12px",
              color: "#7C8DB0",
            }}
          >
            {`${
              baseAmount.toString().split(".")[1]?.length > 2
                ? baseAmount.toFixed(2)
                : baseAmount
            } ${currencyExchangeDetails?.baseCurrency} = ${
              convertedAmount.toString().split(".")[1]?.length > 2
                ? convertedAmount.toFixed(2)
                : convertedAmount
            } ${clientCurrencyShortForm}`}
          </span>
        </div>
      );
    }
  };

  const currencyConversion: boolean =
    currencyExchangeDetails?.baseCurrency !== clientCurrencyShortForm &&
    currencyExchangeDetails?.rate
      ? true
      : false;

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label?.split("^")[0]} {data?.label?.split("^")[1]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label?.split("^")[2]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const checkBottom = (e: any) => {
    setOffset((prv: any) => prv + limit);
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="row ml-3 mt-3 col-md-12 d-flex justify-content-center">
        <div className="col-md-7"></div>
        <div
          className=" p-0 col-md-5 d-flex align-items-center justify-content-center rounded"
          style={{
            border: "1px solid rgba(0, 0, 0, 0.125)",
            width: "100%",
            background: "#eef1f4",
          }}
        >
          <div className="w-100">
            {(data && data.length) ||
            (data &&
              Object.keys(data).length > 0 &&
              Object.getPrototypeOf(data) === Object.prototype) ? (
              <>
                <div
                  className=" p-3 d-flex align-items-center justify-content-left"
                  style={{ gap: "5%" }}
                >
                  <div style={{ fontSize: "16px", width: "40%" }}>
                    Invoice value
                  </div>
                  <div
                    className="w-50"
                    style={{ fontSize: "15px", fontWeight: 600 }}
                  >
                    {currentCurrencyDetails?.currencySign
                      ? currentCurrencyDetails?.currencySign
                      : currencySign}{" "}
                    {totalValue}
                    {showConvertedCurrency(totalValue, 0)}
                  </div>
                </div>
                <div
                  className=" pl-3 pr-3 d-flex align-items-center justify-content-left"
                  style={{ gap: "5%" }}
                >
                  <div
                    className="mb-2"
                    style={{
                      marginTop: currencyConversion ? "32px" : "19px",
                      width: "40%",
                    }}
                  >
                    <RadioContainer
                      optionsList={TDS_TCS_RADIO_OPTIONS}
                      handleSetRadioValue={handleChangeRadioValue}
                      radioValue={changeTCSTDSRadioValue?.toString()}
                      alignment="horizontal"
                    />
                  </div>
                  <div
                    className="w-50 mb-2"
                    style={{
                      marginTop: currencyConversion ? "32px" : "19px",
                    }}
                  >
                    <Select
                      options={
                        tdsTcsdata
                          ? [
                              {
                                label: "Select...",
                                value: 0,
                                id: 0,
                                section_name: "",
                              },
                              ...tdsTcsdata,
                            ]
                          : [
                              {
                                label: "Select...",
                                value: 0,
                                id: 0,
                                section_name: "",
                              },
                            ]
                      }
                      value={tdsTcsvalue}
                      components={{ Option }}
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        setTdsChanges(false);
                        if (e?.value) {
                          let totalTDSTCSValue: number =
                            (e?.id / 100) * taxableValueSum;
                          if (changeTCSTDSRadioValue === "TDS") {
                            setTds(totalTDSTCSValue?.toFixed(2));
                            setTcs(0);
                          } else {
                            setTcs(+totalTDSTCSValue?.toFixed(2));
                            setTds(0);
                          }

                          setTdsTcsValue({
                            label: e?.label?.split("^")[0],
                            value: e?.value,
                            id: e?.id,
                            section_name: e?.section_name,
                          });
                        } else {
                          setTds(0);
                          setTcs(0);
                          setTdsTcsValue({
                            label: "Select..",
                            value: null,
                            id: 0,
                            rate: 0,
                            section_name: "",
                          });
                        }
                      }}
                      isSearchable={true}
                      isLoading={masterFetching}
                      onMenuClose={() => setOffset(0)}
                      onMenuScrollToBottom={checkBottom}
                      onInputChange={(e) => {
                        setText(e);
                        setOffset(0);
                      }}
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-center justify-content-left pl-3 pr-3"
                  style={{ gap: "5%" }}
                >
                  <div
                    style={{
                      width: "40%",
                      // textAlign: "end",

                      fontWeight: "600",
                    }}
                  >
                    {changeTCSTDSRadioValue === "TDS" &&
                      tds !== 0 &&
                      tds !== "" &&
                      showConvertedCurrency(tds, 0)}
                    {changeTCSTDSRadioValue === "TCS" &&
                      tcs !== 0 &&
                      tcs !== "" &&
                      showConvertedCurrency(tcs, 0)}
                  </div>
                  <div
                    className="form-group mt-1 w-50"
                    style={{
                      marginBottom: tds !== 0 ? "0px" : "",
                    }}
                  >
                    <input
                      type="number"
                      step="any"
                      disabled={!tdsTcsvalue?.value ? true : false}
                      className="form-control"
                      onWheel={(event) => event.currentTarget.blur()}
                      value={changeTCSTDSRadioValue === "TDS" ? tds : tcs}
                      onChange={(e) => {
                        if (changeTCSTDSRadioValue === "TDS") {
                          setTds(+e.target.value);
                        } else {
                          setTcs(+e.target.value);
                        }
                      }}
                    />
                  </div>
                </div>
                <hr className="m-0 mt-3"></hr>
                <div
                  className="d-flex align-items-center justify-content-left pl-3 pr-3 pt-2"
                  style={{ gap: "5%" }}
                >
                  <div style={{ width: "40%" }}></div>
                </div>
                <div
                  className="d-flex align-items-center justify-content-left pl-3 pr-3 pb-3"
                  style={{ gap: "5%" }}
                >
                  <div
                    style={{
                      marginTop:
                        currencyConversion && tds !== 0 && tds !== ""
                          ? "30px"
                          : "21px",
                      fontSize: "16px",
                      width: "40%",
                    }}
                  >
                    Total Value
                  </div>

                  <div
                    style={{
                      marginTop:
                        currencyConversion && tds !== 0 && tds !== ""
                          ? "30px"
                          : "21px",
                      fontSize: "15px",
                      fontWeight: 600,
                    }}
                  >
                    {currentCurrencyDetails?.currencySign
                      ? currentCurrencyDetails?.currencySign
                      : currencySign}{" "}
                    {(changeTCSTDSRadioValue === "TDS"
                      ? totalValue - tds
                      : totalValue + +tcs
                    )
                      ?.toString()
                      ?.split(".")[1]?.length > 2
                      ? (changeTCSTDSRadioValue === "TDS"
                          ? totalValue - tds
                          : totalValue + +tcs
                        )?.toFixed(2)
                      : changeTCSTDSRadioValue === "TDS"
                      ? totalValue - tds
                      : totalValue + +tcs}
                    {showConvertedCurrency(
                      totalValue,
                      changeTCSTDSRadioValue === "TDS" ? tds : +tcs,
                      changeTCSTDSRadioValue === "TDS" ? "minus" : "plus"
                    )}
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  masterFetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  tdsDataList: state.masterData.tdsDataList,
  tdsDataTotalCount: state.masterData.totalCount,
  tcsDataTotalCount: state.masterData.totalCount,
  success: state.masterData.success,
  message: state.masterData.message,
  tcsDataList: state.masterData.tcsDataList,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetTdsList: () => dispatch(resetTdsModuleList()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetSingleTdsDataAction: () => dispatch(resetTdsSingleData()),
  dispatchGetTdsModuleAction: (data: GetTdsMasterPayloadType) =>
    dispatch(getMasterTdsModuleAction(data)),
  dispatchGetTcsModuleAction: (data: GetTdsMasterPayloadType) =>
    dispatch(getMasterTcsModuleAction(data)),
  dispatchResetTcsList: () => dispatch(resetTcsModuleList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TDSTCS);
